import React from 'react'

import { Body3, Join, Space } from '@gousto-internal/citrus-react'
import PropTypes from 'prop-types'

const NutritionDisclaimerText = ({ numPortions }) => (
  <Join separator={<Space size={2} />}>
    <Body3>
      &#42;Gousto’s nutritional information only applies to ingredients supplied by Gousto. The
      cooking process and additional ingredients added at home (listed under “What you’ll need”)
      will affect total values.
    </Body3>
    <Body3>
      <span>Portion sizes are based on the quantities used in a {numPortions} person box.</span>
    </Body3>
  </Join>
)

NutritionDisclaimerText.propTypes = {
  numPortions: PropTypes.number.isRequired,
}

export { NutritionDisclaimerText }
